import { autoinject, bindable, computedFrom } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
import { LookupHierarchyControl } from "./lookup-hierarchy-control";
import { LookupValue } from "../../../../models/lookups/lookup.models";
import { Reflection } from "../../../../utilities/reflection";

@autoinject
@transient()
export class LookupHierarchyList {

    constructor(private element: Element) { }

    @bindable
    public itemSource: LookupValue[];

    @bindable
    public change: any;

    @bindable
    public vm: LookupHierarchyControl;

    @computedFrom(Reflection.getPropertyPath<LookupHierarchyList>(x => x.itemSource))
    public get filteredItemSource(): LookupValue[] {
        return (this.itemSource || []).filter(x => x.isActive);
    }

    public isSelected(values: any[], lookup: any) {
        let result = false;
        if (values && values.length > 0) {
            for (let i = 0; i < values.length; i++) {
                if (lookup && values[i].id == lookup.id) {
                    return true;
                } else if (values[i].children) {
                    result = this.isSelected(values[i].children, lookup);
                    if (result) {
                        return true;
                    }
                }
            }
        }
        return result;
    }

    public selectItem(lookup: any) {
        this.vm.selectItem(lookup);

        const changeEvent = new CustomEvent('change', {
            detail: {
                value: lookup
            },
            bubbles: true
        });

        this.element.dispatchEvent(changeEvent);
    }

}
